import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import {BsCloudDownload} from 'react-icons/bs';

let DownloadTableButton = (props) => {
    return (
        <IconButton 
            aria-label="Download"
            onClick={() => props.onClick()}
        >
            <BsCloudDownload />
        </IconButton>
    );
}

export default DownloadTableButton;

  